import React from 'react';
import { Select as AntSelect, SelectProps } from 'antd';

import Tooltip from '$/components/Tooltip';
import styles from './index.module.scss';
import IconFont from '../../IconFont';

const { Option } = AntSelect;

function Select(props: SelectProps & { tooltip?: boolean; }) {
  const selectProps = { ...props, options: undefined };
  const {
    value, options, tooltip, allowClear,
  } = props;
  return (
    <AntSelect
      className={styles.Select}
      suffixIcon={null}
      value={value}
      popupClassName={styles.selectPopupRsetClassName}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...selectProps}
    >
      {options?.map((item) => (
        <Option key={item.value} value={item.value} label={item.label}>
          <div className={styles.tooltipBox}>
            <Tooltip title={item.label} isHideToolTip={!tooltip}>
              <div className={styles.optionBox}>
                <div className={styles.option}>
                  <div className={styles.selectIconBox}>
                    {value === item.value && <IconFont name="checkBoxMark" fontSize={12} className={styles.selectedIcon} />}
                  </div>
                  <div>{item.label}</div>
                </div>
                <IconFont
                  name="chevronDownFill"
                  fontSize={20}
                  className={styles.arrow}
                  style={{ visibility: (!value || (value && !allowClear)) ? 'visible' : 'hidden' }}
                />
              </div>
            </Tooltip>
          </div>
        </Option>
      ))}
    </AntSelect>
  );
}

export default Select;
